// Utility to map human-readable menu labels to existing route paths.
// Adjust mappings if backend routes differ.

const slug = (s) => s.toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');

export function pathFor(dept, ...parts){
  const baseMap = {
    'Trust Signal':   '/signal',
    'Bread':          '/bread',
    'Ethics':         '/ethics',
    'Data':           '/data',
    'KRO Exchange':   '/kro-exchange',
    // Legacy: Settlement Hub was a top-level department before it moved under
    // KRO Exchange. Kept so old bookmarks and stored paths still resolve.
    'Settlement Hub': '/settlement-hub'
  };
  const root = baseMap[dept] || '/' + slug(dept);
  if(!parts.length) return root;
  return root + '/' + parts.map(slug).join('/');
}
